import api from '../axios.config';
import { API_ENDPOINTS, createEndpoint } from './endpoints';

export const SkillResolutionService = {
  // Queue tab — unmapped skill norms grouped by name, awaiting a curator
  // decision (map/alias/new skill/block/ignore).
  getQueue: async ({
    status,
    side,
    minOccurrences,
    sort,
    suggested,
    search,
    page,
    pageSize,
  }) => {
    const endpoint = createEndpoint(API_ENDPOINTS.SKILL_RESOLUTION.GETQUEUE, {
      status,
      side,
      min_occurrences: minOccurrences,
      sort,
      // Filters to rows whose suggested_action matches — map/alias/new_skill
      // /ignore. Omitted entirely (not "all") when unset, per the API's own
      // convention here.
      suggested,
      search,
      page,
      pageSize,
    });
    const response = await api.get(endpoint);
    return response;
  },

  // Record detail — the full picture for one norm (real variant counts,
  // nearest-match distribution, affected candidate/requirement rows, a
  // collision preview for the exact/nearest target, and real history).
  // name_norm can contain spaces, so it's percent-encoded before it goes
  // into the path — createEndpoint's `:param` substitution doesn't encode.
  getQueueDetail: async (nameNorm) => {
    const endpoint = createEndpoint(
      API_ENDPOINTS.SKILL_RESOLUTION.GETQUEUEDETAIL,
      { nameNorm: encodeURIComponent(nameNorm) }
    );
    const response = await api.get(endpoint);
    return response;
  },

  // The four wired resolve actions — each takes the exact body the record
  // modal builds and returns whatever the server's envelope is (unconfirmed
  // shape, so callers shouldn't assume fields beyond a 2xx meaning success).
  resolveNewSkill: async (body) => {
    const response = await api.post(
      API_ENDPOINTS.SKILL_RESOLUTION.RESOLVENEWSKILL,
      body
    );
    return response;
  },
  resolveAlias: async (body) => {
    const response = await api.post(
      API_ENDPOINTS.SKILL_RESOLUTION.RESOLVEALIAS,
      body
    );
    return response;
  },
  resolveMap: async (body) => {
    const response = await api.post(
      API_ENDPOINTS.SKILL_RESOLUTION.RESOLVEMAP,
      body
    );
    return response;
  },
  resolveBlock: async (body) => {
    const response = await api.post(
      API_ENDPOINTS.SKILL_RESOLUTION.RESOLVEBLOCK,
      body
    );
    return response;
  },
};
